/*
  Digismoothie Gift Box does not add the free gift during cart SSR. On /cart it
  waits for DOMContentLoaded, then app-info, a React bundle, product preloads,
  and only then addEligibleOffersToCart — several /cart and offers round trips
  that live QA measured at about 7–8s before the ghost line existed.

  Two earlier writes, using the same offers API and the same ghost variant Gift
  Box would POST:

  1. Product pages. EComposer awaits /cart/add, then waits 500ms and navigates
     to /cart. Holding that response until the ghost variant is in the cart
     means the cart document already contains the free gift (first paint).

  2. /cart fallback, when the line is still missing (refresh, or a navigation
     that did not go through /cart/add). Offers and cart.js start from the head,
     before Gift Box's blocking script. One /cart/update.js carries the section
     HTML and we paint it. That is one Cart API round trip, not Gift Box's boot.

  Registering the theme on GIFTBOX_SUPPORTED_THEMES_LIST stops Gift Box from
  location.reload() once it catches up. Our update sends giftbox_internal so
  Gift Box does not treat it as a shopper edit. When Gift Box later writes the
  same quantity, it does not reload.
*/
(function () {
  if (window.__skoonGiftCartSyncStarted) return;
  window.__skoonGiftCartSyncStarted = true;

  var POLL_MS = 400;
  var MAX_MS = 20000;
  var RETRY_GAP_MS = 1000;
  var MAX_FAILS_PER_SIG = 12;
  var ADD_SEED_BUDGET_MS = 1600;

  var boot = window.__skoonGiftBoot || (window.__skoonGiftBoot = {});
  var syncing = false;
  var syncTimer = 0;
  var lastDomSig = null;
  var attempt = { sig: '', at: 0, fails: 0 };
  var earlySeedStarted = false;
  var paintObserver = null;

  function registerTheme() {
    var name = window.Shopify && window.Shopify.theme && window.Shopify.theme.name;
    if (!name) return;
    var supportedThemes = window.GIFTBOX_SUPPORTED_THEMES_LIST || [];
    if (supportedThemes.indexOf(name) === -1) supportedThemes.push(name);
    window.GIFTBOX_SUPPORTED_THEMES_LIST = supportedThemes;
  }

  registerTheme();

  function inDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function rootPath() {
    if (boot.root) return boot.root.charAt(boot.root.length - 1) === '/' ? boot.root : boot.root + '/';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function cartJsUrl() {
    return boot.cartJs || rootPath() + 'cart.js';
  }

  function updateUrl() {
    if (boot.updateUrl) return boot.updateUrl;
    var routes = window.MinimogSettings && window.MinimogSettings.routes;
    return (routes && routes.cart_update_url) || rootPath() + 'cart/update.js';
  }

  function offersUrl() {
    var shop = boot.shop || (window.Shopify && window.Shopify.shop) || '';
    return 'https://giftbox.digismoothie.app/api/offers?shop=' + encodeURIComponent(shop);
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function withTimeout(promise, ms) {
    return new Promise(function (resolve) {
      var settled = false;
      var timer = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        resolve(null);
      }, ms);
      Promise.resolve(promise).then(
        function (value) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          resolve(value);
        },
        function () {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          resolve(null);
        }
      );
    });
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function now() {
    return window.performance && typeof performance.now === 'function' ? performance.now() : Date.now();
  }

  function isCartWriteUrl(url) {
    return /\/cart(?:\.js|\/(?:update|change|add|clear)(?:\.js)?)(?:\?|#|$)/.test(String(url || ''));
  }

  function isCartAddUrl(url) {
    return /\/cart\/add(?:\.js)?(?:\?|#|$)/.test(String(url || ''));
  }

  function isOurRequest(input, init) {
    try {
      var headers = new Headers((init && init.headers) || (input && input.headers) || undefined);
      return headers.get('X-Skoon-Gift-Sync') === '1';
    } catch (error) {
      return false;
    }
  }

  function signature(parts) {
    return parts.slice().sort().join('|');
  }

  function linesFromCart(cart) {
    return ((cart && cart.items) || []).map(function (item) {
      return String(item.variant_id) + ':' + String(item.quantity);
    });
  }

  function qtyOf(input) {
    if (!input) return '';
    var attr = input.getAttribute('value');
    if (input.isConnected && input.value != null && String(input.value) !== '') return String(input.value);
    return attr != null ? String(attr) : '';
  }

  function linesFrom(root) {
    var scope = root && root.querySelector ? root.querySelector('[data-minimog-cart-items]') || root : root;
    if (!scope || !scope.querySelectorAll) return [];
    var nodes = scope.querySelectorAll('.m-cart__items > [data-cart-item]');
    if (!nodes.length) nodes = scope.querySelectorAll('[data-cart-item]');
    var parts = [];
    nodes.forEach(function (node) {
      var input = node.querySelector('input[name="updates[]"][data-quantity-variant-id], input[data-quantity-variant-id]');
      if (input) {
        parts.push(String(input.getAttribute('data-quantity-variant-id') || '') + ':' + qtyOf(input));
      } else {
        parts.push('product:' + (node.getAttribute('data-product-id') || ''));
      }
    });
    return parts;
  }

  function sectionIds() {
    var ids = [];
    if (boot.sectionId) ids.push(boot.sectionId);
    var cartEl = document.querySelector('m-cart');
    var section = cartEl && cartEl.closest ? cartEl.closest('[id^="shopify-section-"]') : null;
    var fromDom = section && section.id ? section.id.replace(/^shopify-section-/, '') : '';
    if (fromDom && ids.indexOf(fromDom) === -1) ids.push(fromDom);
    if (ids.indexOf('cart-template') === -1) ids.push('cart-template');
    return ids;
  }

  function whenSectionId() {
    if (boot.sectionId) return Promise.resolve(boot.sectionId);
    return new Promise(function (resolve) {
      var previous = boot.onSection;
      boot.onSection = function () {
        if (typeof previous === 'function') previous();
        resolve(boot.sectionId || '');
      };
      window.setTimeout(function () {
        resolve(boot.sectionId || '');
      }, 2000);
    });
  }

  function htmlMatches(html, liveSig) {
    if (!html) return false;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    return signature(linesFrom(parsed)) === liveSig;
  }

  function applySection(html, itemCount) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var painted = false;
    ['[data-minimog-cart-items]', '[data-cart-subtotal]', '[data-minimog-cart-discounts]', '[data-minimog-gift-wrapping]'].forEach(
      function (selector) {
        var next = parsed.querySelector(selector);
        var current = document.querySelector(selector);
        if (next && current) {
          current.innerHTML = next.innerHTML;
          painted = true;
        }
      }
    );
    if (!painted) return false;

    var cartEl = document.querySelector('m-cart');
    if (cartEl) cartEl.classList.toggle('m-cart--empty', itemCount === 0);

    document.querySelectorAll('.m-cart-count-bubble').forEach(function (bubble) {
      if (itemCount > 0) {
        bubble.textContent = String(itemCount);
        bubble.classList.remove('m:hidden');
      } else {
        bubble.classList.add('m:hidden');
      }
    });

    try {
      window.FoxKitV2?.Modules?.InCart?.getCart?.();
    } catch (error) {}

    lastDomSig = signature(linesFrom(document));
    if (boot.timing) boot.timing.paintedAt = now();
    return true;
  }

  function pickHtml(sections, ids, liveSig) {
    if (!sections) return '';
    for (var i = 0; i < ids.length; i++) {
      if (htmlMatches(sections[ids[i]], liveSig)) return sections[ids[i]];
    }
    var keys = Object.keys(sections);
    for (var j = 0; j < keys.length; j++) {
      if (htmlMatches(sections[keys[j]], liveSig)) return sections[keys[j]];
    }
    return '';
  }

  async function postSections(ids, liveSig) {
    var response = await fetch(updateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Skoon-Gift-Sync': '1'
      },
      body: JSON.stringify({
        sections: ids,
        sections_url: window.location.pathname,
        giftbox_internal: true
      })
    });
    if (!response.ok) return '';
    var data = await response.json();
    return pickHtml(data && data.sections, ids, liveSig);
  }

  async function getSection(id, liveSig) {
    var response = await fetch(rootPath() + 'cart?section_id=' + encodeURIComponent(id) + '&gift_sync=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'text/html',
        'X-Skoon-Gift-Sync': '1'
      }
    });
    if (!response.ok) return '';
    var html = await response.text();
    return htmlMatches(html, liveSig) ? html : '';
  }

  async function refreshSection(liveSig, itemCount) {
    var ids = sectionIds();
    var html = '';
    try {
      html = await postSections(ids, liveSig);
    } catch (error) {
      html = '';
    }
    if (!html) {
      for (var i = 0; i < ids.length && !html; i++) {
        try {
          html = await getSection(ids[i], liveSig);
        } catch (error) {
          html = '';
        }
      }
    }
    if (!html) return false;
    return applySection(html, typeof itemCount === 'number' ? itemCount : 0);
  }

  function paintWhenReady(html, itemCount, liveSig) {
    function tryPaint() {
      if (!document.querySelector('[data-minimog-cart-items]')) return false;
      if (html) return applySection(html, itemCount);
      refreshSection(liveSig, itemCount);
      return true;
    }
    if (tryPaint()) return;
    if (paintObserver) paintObserver.disconnect();
    paintObserver = new MutationObserver(function () {
      if (tryPaint() && paintObserver) paintObserver.disconnect();
    });
    paintObserver.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      if (paintObserver) paintObserver.disconnect();
    }, 8000);
  }

  async function readCart() {
    var response = await fetch(cartJsUrl() + '?gift_sync=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        'X-Skoon-Gift-Sync': '1'
      }
    });
    if (!response.ok) return null;
    var cart = await response.json();
    if (!cart || !Array.isArray(cart.items)) return null;
    return cart;
  }

  function cacheKey() {
    return 'skoon-gift-offers:' + (boot.shop || (window.Shopify && window.Shopify.shop) || '');
  }

  function rememberOffers(data) {
    try {
      sessionStorage.setItem(cacheKey(), JSON.stringify({ at: Date.now(), data: data }));
    } catch (error) {}
  }

  function fetchOffers() {
    return fetch(offersUrl(), { credentials: 'omit', mode: 'cors' }).then(function (response) {
      if (!response.ok) throw new Error('offers');
      return response.json();
    }).then(function (data) {
      rememberOffers(data);
      return data;
    });
  }

  function offersReady() {
    if (!boot.offersPromise || boot.offersFailed) {
      boot.offersFailed = false;
      boot.offersPromise = fetchOffers();
    }
    return Promise.resolve(boot.offersPromise).then(
      function (data) {
        return data;
      },
      function () {
        boot.offersFailed = true;
        boot.offersPromise = null;
        return null;
      }
    );
  }

  function storedOffers() {
    try {
      var raw = localStorage.getItem('giftbox-added-offers');
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function sameId(left, right) {
    return String(left) === String(right);
  }

  function isRejected(offer) {
    var stored = storedOffers();
    var productId = offer.shopify_product_id;
    var byProduct = stored.filter(function (item) {
      return item && sameId(item.productId, productId);
    });
    if (byProduct.length) return !!byProduct[0].rejected;
    return stored.some(function (item) {
      return item && sameId(item.offerId, offer.id) && item.rejected;
    });
  }

  function countryOk(offer) {
    var list = offer.available_in_countries;
    if (!list || !list.length) return true;
    var country = window.Shopify && window.Shopify.country;
    if (!country) return true;
    return list.indexOf(country) !== -1;
  }

  function offerRecords(offersResp) {
    if (!offersResp || !offersResp.settings) return [];
    if (offersResp.settings.use_ghost_products === false) return [];
    if (offersResp.settings.gift_only_highest_gift) return [];
    return offersResp.offers || [];
  }

  function ghostVariantId(offer) {
    var variants = (offer.ghost_product && offer.ghost_product.variants) || [];
    if (!variants.length) return null;
    var preferred = offer.shopify_product_variant_id;
    var i;
    if (preferred) {
      for (i = 0; i < variants.length; i++) {
        if (sameId(variants[i].parent_shopify_variant_id, preferred)) return variants[i].shopify_variant_id;
      }
    }
    if (variants.length === 1) return variants[0].shopify_variant_id;
    var parents = offer.shopify_product_variants || [];
    if (parents.length === 1) {
      for (i = 0; i < variants.length; i++) {
        if (sameId(variants[i].parent_shopify_variant_id, parents[0])) return variants[i].shopify_variant_id;
      }
    }
    return null;
  }

  function lineQty(cart, variantId) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (sameId(items[i].variant_id, variantId)) return items[i].quantity || 0;
    }
    return 0;
  }

  function targetQty(cart, offer) {
    var qty = 0;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!sameId(item.product_id, offer.target_shopify_product_id)) continue;
      var variants = offer.target_shopify_product_variants || [];
      var variantOk = offer.target_all_variants_selected || variants.some(function (id) {
        return sameId(id, item.variant_id);
      });
      if (variantOk) qty += item.quantity || 0;
    }
    return qty;
  }

  function productGiftQty(cart, offer, matchedQty) {
    if (offer.gift_quantity !== 0) return offer.gift_quantity || 1;
    return matchedQty || 1;
  }

  function canSeedOffer(offer) {
    if (!offer || offer.type !== 'ProductOffer') return false;
    if (offer.enabled === false || offer.status === 'DISABLED') return false;
    if (!offer.ghost_product) return false;
    if (!countryOk(offer)) return false;
    if (isRejected(offer)) return false;
    return true;
  }

  function productAddedUpdates(cart, offersResp) {
    var updates = {};
    offerRecords(offersResp).forEach(function (offer) {
      if (!canSeedOffer(offer) || offer.threshold_mode !== 'product_added') return;
      var matched = targetQty(cart, offer);
      var minimum = offer.target_min_quantity == null ? 1 : offer.target_min_quantity;
      if (matched < minimum) return;
      var variantId = ghostVariantId(offer);
      if (!variantId) return;
      var want = productGiftQty(cart, offer, matched);
      if (want > 0 && lineQty(cart, variantId) !== want) updates[String(variantId)] = want;
    });
    return updates;
  }

  function collectionIdsIn(list, productId) {
    for (var i = 0; i < list.length; i++) {
      if (sameId(list[i], productId)) return true;
    }
    return false;
  }

  function collectionAddedUpdates(cart, offersResp, collections) {
    var updates = {};
    if (!collections || typeof collections !== 'object') return updates;
    offerRecords(offersResp).forEach(function (offer) {
      if (!canSeedOffer(offer) || offer.threshold_mode !== 'collection_added') return;
      var ids = collections[offer.target_shopify_collection_id] || collections[String(offer.target_shopify_collection_id)] || [];
      if (!ids.length) return;
      var matched = 0;
      ((cart && cart.items) || []).forEach(function (item) {
        if (item.product_type === 'giftbox_ghost_product') return;
        if (collectionIdsIn(ids, item.product_id)) matched += item.quantity || 0;
      });
      var minimum = offer.target_min_quantity == null ? 1 : offer.target_min_quantity;
      if (matched < minimum) return;
      var variantId = ghostVariantId(offer);
      if (!variantId) return;
      var want = productGiftQty(cart, offer, matched);
      if (want > 0 && lineQty(cart, variantId) !== want) updates[String(variantId)] = want;
    });
    return updates;
  }

  function addedProductIds(payload) {
    var ids = [];
    if (!payload || typeof payload !== 'object') return ids;
    if (payload.product_id) ids.push(payload.product_id);
    if (Array.isArray(payload.items)) {
      payload.items.forEach(function (item) {
        if (item && item.product_id) ids.push(item.product_id);
      });
    }
    return ids;
  }

  function mightEarnProductGift(payload, offersResp) {
    var ids = addedProductIds(payload);
    var offers = offerRecords(offersResp).filter(function (offer) {
      return offer.threshold_mode === 'product_added' && offer.type === 'ProductOffer';
    });
    if (!offers.length) return false;
    if (!ids.length) return true;
    return offers.some(function (offer) {
      return ids.some(function (id) {
        return sameId(id, offer.target_shopify_product_id);
      });
    });
  }

  async function postUpdates(updates, sectionId) {
    var ids = [];
    if (sectionId) ids.push(sectionId);
    sectionIds().forEach(function (id) {
      if (ids.indexOf(id) === -1) ids.push(id);
    });
    var body = { updates: updates, giftbox_internal: true };
    if (boot.isCart && ids.length) {
      body.sections = ids;
      body.sections_url = window.location.pathname;
    }
    var response = await fetch(updateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Skoon-Gift-Sync': '1'
      },
      body: JSON.stringify(body)
    });
    if (!response.ok) return null;
    var data = await response.json();
    if (boot.isCart && data && Array.isArray(data.items)) {
      var liveSig = signature(linesFromCart(data));
      var html = pickHtml(data.sections, ids, liveSig);
      if (html) paintWhenReady(html, data.item_count, liveSig);
      else paintWhenReady('', data.item_count, liveSig);
    }
    if (boot.timing) boot.timing.updatedAt = now();
    return data;
  }

  function collectionQuery(cart, offersResp) {
    var collectionIds = [];
    offerRecords(offersResp).forEach(function (offer) {
      if (!canSeedOffer(offer) || offer.threshold_mode !== 'collection_added') return;
      if (!offer.target_shopify_collection_id) return;
      if (collectionIds.indexOf(offer.target_shopify_collection_id) === -1) {
        collectionIds.push(offer.target_shopify_collection_id);
      }
    });
    var productIds = [];
    ((cart && cart.items) || []).forEach(function (item) {
      if (!item || item.product_type === 'giftbox_ghost_product') return;
      if (productIds.indexOf(item.product_id) === -1) productIds.push(item.product_id);
    });
    if (!collectionIds.length || !productIds.length) return '';
    var params = new URLSearchParams();
    params.set('shop', boot.shop || (window.Shopify && window.Shopify.shop) || '');
    collectionIds.forEach(function (id) {
      params.append('collection_ids', String(id));
    });
    productIds.forEach(function (id) {
      params.append('product_ids', String(id));
    });
    return 'https://giftbox.digismoothie.app/api/collections-in-cart?' + params.toString();
  }

  async function loadCollections(cart, offersResp) {
    var url = collectionQuery(cart, offersResp);
    if (!url) return {};
    try {
      var response = await fetch(url, { credentials: 'omit', mode: 'cors' });
      if (!response.ok) return {};
      var data = await response.json();
      if (!data || typeof data !== 'object' || Array.isArray(data)) return {};
      return data;
    } catch (error) {
      return {};
    }
  }

  async function seedProductGifts(cart, offersResp, sectionId) {
    if (!cart || inDesignMode()) return cart;
    var productUpdates = productAddedUpdates(cart, offersResp);
    if (!Object.keys(productUpdates).length) return cart;
    var written = await postUpdates(productUpdates, sectionId);
    if (written && Array.isArray(written.items)) return written;
    return cart;
  }

  function startEarlySeed() {
    if (earlySeedStarted || !boot.isCart || !boot.hasItems || inDesignMode()) return;
    earlySeedStarted = true;
    boot.timing = boot.timing || { startedAt: now() };
    Promise.all([
      boot.cartPromise ? Promise.resolve(boot.cartPromise).catch(function () { return readCart(); }) : readCart(),
      offersReady(),
      whenSectionId()
    ]).then(function (parts) {
      var cart = parts[0];
      var offersResp = parts[1];
      var sectionId = parts[2] || boot.sectionId || '';
      var collectionsPromise = loadCollections(cart, offersResp);
      return seedProductGifts(cart, offersResp, sectionId).then(function (nextCart) {
        return collectionsPromise.then(function (collections) {
          var updates = collectionAddedUpdates(nextCart || cart, offersResp, collections);
          if (!Object.keys(updates).length) return nextCart;
          return postUpdates(updates, sectionId);
        });
      });
    }).catch(function () {});
  }

  var addSeedInFlight = null;

  async function seedAfterAddInner(response) {
    if (inDesignMode()) return;
    var offersResp = await offersReady();
    var payload = null;
    try {
      payload = await response.clone().json();
    } catch (error) {
      payload = null;
    }
    if (!mightEarnProductGift(payload, offersResp)) return;
    var cart = await readCart();
    if (!cart) return;
    var sectionId = boot.isCart ? boot.sectionId || '' : '';
    if (boot.isCart && !sectionId) sectionId = await withTimeout(whenSectionId(), 400);
    await seedProductGifts(cart, offersResp, sectionId || '');
  }

  function seedAfterAdd(response) {
    if (addSeedInFlight) return addSeedInFlight;
    addSeedInFlight = withTimeout(seedAfterAddInner(response), ADD_SEED_BUDGET_MS).then(function (value) {
      addSeedInFlight = null;
      return value;
    });
    return addSeedInFlight;
  }

  async function maybePaint(cart) {
    var liveSig = signature(linesFromCart(cart));
    var renderedSig = signature(linesFrom(document));
    lastDomSig = renderedSig;
    if (liveSig === renderedSig) return false;

    var at = now();
    if (attempt.sig !== liveSig) attempt.fails = 0;
    if (attempt.sig === liveSig && attempt.fails >= MAX_FAILS_PER_SIG) return false;
    if (attempt.sig === liveSig && at - attempt.at < RETRY_GAP_MS) {
      window.setTimeout(scheduleSync, Math.max(50, RETRY_GAP_MS - (at - attempt.at) + 30));
      return false;
    }

    attempt.sig = liveSig;
    attempt.at = at;
    var painted = false;
    try {
      painted = await refreshSection(liveSig, cart.item_count);
    } catch (error) {
      painted = false;
    }
    if (!painted) attempt.fails += 1;
    else attempt.fails = 0;
    return painted;
  }

  async function syncFromNetwork() {
    if (syncing) return;
    if (!document.querySelector('m-cart')) return;
    syncing = true;
    try {
      registerTheme();
      watchCart();
      var cart = await readCart();
      if (cart) await maybePaint(cart);
    } catch (error) {
    } finally {
      syncing = false;
    }
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      syncFromNetwork();
    }, 80);
  }

  function installFetchHook() {
    if (!window.fetch || window.fetch.__skoonGiftCart) return;
    var orig = window.fetch.bind(window);
    var wrapped = function (input, init) {
      var run = orig(input, init);
      var url = requestUrl(input);
      if (isOurRequest(input, init) || !isCartWriteUrl(url)) return run;
      return Promise.resolve(run).then(function (response) {
        if (response && response.ok && isCartAddUrl(url)) {
          return seedAfterAdd(response).then(function () {
            scheduleSync();
            return response;
          });
        }
        scheduleSync();
        return response;
      });
    };
    wrapped.__skoonGiftCart = true;
    window.fetch = wrapped;
  }

  function installXhrHook() {
    var proto = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
    if (!proto || (proto.send && proto.send.__skoonGiftCart)) return;
    var open = proto.open;
    var send = proto.send;
    proto.open = function (method, url) {
      this.__skoonUrl = url;
      return open.apply(this, arguments);
    };
    var wrappedSend = function (body) {
      var xhr = this;
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300 && isCartWriteUrl(xhr.__skoonUrl)) scheduleSync();
      });
      return send.apply(xhr, arguments);
    };
    wrappedSend.__skoonGiftCart = true;
    proto.send = wrappedSend;
  }

  function watchCart() {
    var cartEl = document.querySelector('m-cart');
    var section = cartEl && cartEl.closest ? cartEl.closest('[id^="shopify-section-"]') : null;
    var parent = (section && section.parentElement) || document.getElementById('MainContent');
    if (!parent || parent.__skoonGiftWatch) return;
    parent.__skoonGiftWatch = true;
    var timer = 0;
    var observer = new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        var renderedSig = signature(linesFrom(document));
        if (renderedSig === lastDomSig) return;
        scheduleSync();
      }, 120);
    });
    observer.observe(parent, { childList: true, subtree: true });
  }

  async function poll() {
    var started = now();
    while (now() - started < MAX_MS) {
      await syncFromNetwork();
      if (now() - started >= MAX_MS) break;
      await wait(now() - started < 8000 ? POLL_MS : 1000);
    }
  }

  function rehook() {
    installFetchHook();
    installXhrHook();
    if (boot.isCart) watchCart();
  }

  function onReady() {
    registerTheme();
    rehook();
    if (boot.isCart && boot.hasItems && !inDesignMode()) poll();
  }

  window.__skoonGiftDebug = {
    productAddedUpdates: productAddedUpdates,
    collectionAddedUpdates: collectionAddedUpdates,
    ghostVariantId: ghostVariantId,
    mightEarnProductGift: mightEarnProductGift
  };

  boot.timing = { startedAt: now() };
  installFetchHook();
  installXhrHook();
  if (boot.isCart && boot.hasItems) startEarlySeed();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady);
  else onReady();

  window.setTimeout(rehook, 0);
  document.addEventListener('DOMContentLoaded', function () {
    window.setTimeout(rehook, 0);
  });
  document.addEventListener('GIFTBOX_CART_UPDATED', scheduleSync);
})();
